<template>
    <div>
        <button class="c-top-nav__link btn btn-link-plain" v-b-modal="modalId">
            <img :src="searchIcon" alt=""><span class="sr-only">{{ searchLabel }}</span>
        </button>

        <aha-modal :id="modalId" class="c-site-search-modal global-search-section" hide-footer hide-header lazy @shown="onShown">
            <b-btn-close @click="$root.$emit('bv::hide::modal', modalId, $event.target)">×</b-btn-close>
                <form :action="formAction" class="c-inline-search__form" role="search">
                    <div class="c-inline-search__search form-group form-group--horizontal">
                        <label :for="inputId" class="col-form-label-lg">{{ searchLabel }}</label>
                        <input v-model="searchQuery" type="text" class="c-inline-search__input form-control form-control-lg" ref="search" :id="inputId" :name="inputName" :placeholder="placeholderText">
                    </div>
                    <input type="submit" @click.prevent="search" :value="searchButton" class="c-inline-search__submit btn btn-lg btn-danger btn-round" />
                </form>
        </aha-modal>
    </div>
</template>

<script>
    import idMixin from '@/mixins/aha-id';

    export default {
        mixins: [idMixin],
        data() {
            return {
                searchQuery: '',
                inputId: this.safeId() + '__search',
                modalId: this.safeId() + '__modal'
            };
        },
        props: {
            formAction: {
                type: String,
                required: true
            },
            searchLabel: {
                type: String,
                default: 'Search'
            },
            placeholderText: {
                type: String,
                default: 'ex: Heart Attack Symptoms'
            },
            inputName: {
                type: String,
                default: 'query'
            },
            searchIcon: {
                type: String,
                default: '/assets/glyphs/search.svg'
            },
            searchButton: {
                type: String,
                default: 'Search'
            },
            queryDelimiter: {
                type: String,
                default: '?'
            }
        },
        methods: {
            hideModal() {
                this.$refs.locationSelectorModal.hide();
            },
            onShown() {
                this.$nextTick(() => {
                    this.$nextTick(() => {
                        this.$refs.search.focus();
                    });
                });
            },
            search() {
                let url = this.formAction;
                if(this.searchQuery !== '') {
                    url += this.queryDelimiter + this.inputName + '=' + this.searchQuery;
                }
                window.location.href = url;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/app/components/aha-inline-site-search.vue